import { fadeInScaleUpTransition as l } from "../../../_styles/transitions/fade-in-scale-up.cssr.js";
import { iconSwitchTransition as a } from "../../../_styles/transitions/icon-switch.cssr.js";
import { c as e, cB as r, cM as o, cNotM as n, cE as t, insideModal as d, insidePopover as c } from "../../../_utils/cssr/index.js";
const i = s(), v = e([r("data-table", `
 width: 100%;
 font-size: var(--n-font-size);
 display: flex;
 flex-direction: column;
 position: relative;
 --n-merged-th-color: var(--n-th-color);
 --n-merged-td-color: var(--n-td-color);
 --n-merged-border-color: var(--n-border-color);
 --n-merged-th-color-hover: var(--n-th-color-hover);
 --n-merged-th-color-sorting: var(--n-th-color-sorting);
 --n-merged-td-color-hover: var(--n-td-color-hover);
 --n-merged-td-color-sorting: var(--n-td-color-sorting);
 --n-merged-td-color-striped: var(--n-td-color-striped);
 `, [r("data-table-wrapper", `
 flex-grow: 1;
 display: flex;
 flex-direction: column;
 `), o("flex-height", [e(">", [r("data-table-wrapper", [e(">", [r("data-table-base-table", `
 display: flex;
 flex-direction: column;
 flex-grow: 1;
 `, [e(">", [r("data-table-base-table-body", "flex-basis: 0;", [
  // last-child means there is no empty icon
  // body is a scrollbar, we need to override height 100%
  e("&:last-child", "flex-grow: 1;")
])])])])])])]), e(">", [r("data-table-loading-wrapper", `
 color: var(--n-loading-color);
 font-size: var(--n-loading-size);
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 transition: color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 justify-content: center;
 `, [l({
  originalTransform: "translateX(-50%) translateY(-50%)"
})])]), r("data-table-expand-placeholder", `
 margin-right: 8px;
 display: inline-block;
 width: 16px;
 height: 1px;
 `), r("data-table-indent", `
 display: inline-block;
 height: 1px;
 `), r("data-table-expand-trigger", `
 display: inline-flex;
 margin-right: 8px;
 cursor: pointer;
 font-size: 16px;
 vertical-align: -0.2em;
 position: relative;
 width: 16px;
 height: 16px;
 color: var(--n-td-text-color);
 transition: color .3s var(--n-bezier);
 `, [o("expanded", [r("icon", "transform: rotate(90deg);", [a({
  originalTransform: "rotate(90deg)"
})]), r("base-icon", "transform: rotate(90deg);", [a({
  originalTransform: "rotate(90deg)"
})])]), r("base-loading", `
 color: var(--n-loading-color);
 transition: color .3s var(--n-bezier);
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [a()]), r("icon", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [a()]), r("base-icon", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [a()])]), r("data-table-thead", `
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-merged-th-color);
 `), r("data-table-tr", `
 position: relative;
 box-sizing: border-box;
 background-clip: padding-box;
 transition: background-color .3s var(--n-bezier);
 `, [r("data-table-expand", `
 position: sticky;
 left: 0;
 overflow: hidden;
 margin: calc(var(--n-th-padding) * -1);
 padding: var(--n-th-padding);
 box-sizing: border-box;
 `), o("striped", "background-color: var(--n-merged-td-color-striped);", [r("data-table-td", "background-color: var(--n-merged-td-color-striped);")]), n("summary", [e("&:hover", "background-color: var(--n-merged-td-color-hover);", [e(">", [r("data-table-td", "background-color: var(--n-merged-td-color-hover);")])])])]), r("data-table-th", `
 padding: var(--n-th-padding);
 position: relative;
 text-align: start;
 box-sizing: border-box;
 background-color: var(--n-merged-th-color);
 border-color: var(--n-merged-border-color);
 border-bottom: 1px solid var(--n-merged-border-color);
 color: var(--n-th-text-color);
 transition:
 border-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 font-weight: var(--n-th-font-weight);
 `, [o("filterable", `
 padding-right: 36px;
 `, [o("sortable", `
 padding-right: calc(var(--n-th-padding) + 36px);
 `)]), i, o("selection", `
 padding: 0;
 text-align: center;
 line-height: 0;
 z-index: 3;
 `), t("title-wrapper", `
 display: flex;
 align-items: center;
 flex-wrap: nowrap;
 max-width: 100%;
 `, [t("title", `
 flex: 1;
 min-width: 0;
 `)]), t("ellipsis", `
 display: inline-block;
 vertical-align: bottom;
 text-overflow: ellipsis;
 overflow: hidden;
 white-space: nowrap;
 max-width: 100%;
 `), o("hover", `
 background-color: var(--n-merged-th-color-hover);
 `), o("sorting", `
 background-color: var(--n-merged-th-color-sorting);
 `), o("sortable", `
 cursor: pointer;
 `, [t("ellipsis", `
 max-width: calc(100% - 18px);
 `), e("&:hover", `
 background-color: var(--n-merged-th-color-hover);
 `)]), r("data-table-sorter", `
 height: var(--n-sorter-size);
 width: var(--n-sorter-size);
 margin-left: 4px;
 position: relative;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 vertical-align: -0.2em;
 color: var(--n-th-icon-color);
 transition: color .3s var(--n-bezier);
 `, [r("base-icon", "transition: transform .3s var(--n-bezier)"), o("desc", [r("base-icon", `
 transform: rotate(0deg);
 `)]), o("asc", [r("base-icon", `
 transform: rotate(-180deg);
 `)]), o("asc, desc", `
 color: var(--n-th-icon-color-active);
 `)]), r("data-table-resize-button", `
 width: var(--n-resizable-container-size);
 position: absolute;
 top: 0;
 right: calc(var(--n-resizable-container-size) / 2);
 bottom: 0;
 cursor: col-resize;
 user-select: none;
 `, [e("&::after", `
 width: var(--n-resizable-size);
 height: 50%;
 position: absolute;
 top: 50%;
 left: calc(var(--n-resizable-container-size) / 2);
 bottom: 0;
 background-color: var(--n-merged-border-color);
 transform: translateY(-50%);
 transition: background-color .3s var(--n-bezier);
 z-index: 1;
 content: '';
 `), o("active", [e("&::after", ` 
 background-color: var(--n-th-icon-color-active);
 `)]), e("&:hover::after", `
 background-color: var(--n-th-icon-color-active);
 `)]), r("data-table-filter", `
 position: absolute;
 z-index: auto;
 right: 0;
 width: 36px;
 top: 0;
 bottom: 0;
 cursor: pointer;
 display: flex;
 justify-content: center;
 align-items: center;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 font-size: var(--n-filter-size);
 color: var(--n-th-icon-color);
 `, [e("&:hover", `
 background-color: var(--n-th-button-color-hover);
 `), o("show", `
 background-color: var(--n-th-button-color-hover);
 `), o("active", `
 background-color: var(--n-th-button-color-hover);
 color: var(--n-th-icon-color-active);
 `)])]), r("data-table-td", `
 padding: var(--n-td-padding);
 text-align: start;
 box-sizing: border-box;
 border: none;
 background-color: var(--n-merged-td-color);
 color: var(--n-td-text-color);
 border-bottom: 1px solid var(--n-merged-border-color);
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `, [o("expand", [r("data-table-expand-trigger", `
 margin-right: 0;
 `)]), o("last-row", `
 border-bottom: 0 solid var(--n-merged-border-color);
 `, [
  // make sure there is no overlap between bottom border and
  // fixed column box shadow
  e("&::after", `
 bottom: 0 !important;
 `),
  e("&::before", `
 bottom: 0 !important;
 `)
]), o("summary", `
 background-color: var(--n-merged-th-color);
 `), o("hover", `
 background-color: var(--n-merged-td-color-hover);
 `), o("sorting", `
 background-color: var(--n-merged-td-color-sorting);
 `), t("ellipsis", `
 display: inline-block;
 text-overflow: ellipsis;
 overflow: hidden;
 white-space: nowrap;
 max-width: 100%;
 vertical-align: bottom;
 max-width: calc(100% - var(--indent-offset, -1.5) * 16px - 24px);
 `), o("selection, expand", `
 text-align: center;
 padding: 0;
 line-height: 0;
 `), i]), r("data-table-empty", `
 box-sizing: border-box;
 padding: var(--n-empty-padding);
 flex-grow: 1;
 flex-shrink: 0;
 opacity: 1;
 display: flex;
 align-items: center;
 justify-content: center;
 transition: opacity .3s var(--n-bezier);
 `, [o("hide", `
 opacity: 0;
 `)]), t("pagination", `
 margin: var(--n-pagination-margin);
 display: flex;
 justify-content: flex-end;
 `), r("data-table-wrapper", `
 position: relative;
 opacity: 1;
 transition: opacity .3s var(--n-bezier), border-color .3s var(--n-bezier);
 border-top-left-radius: var(--n-border-radius);
 border-top-right-radius: var(--n-border-radius);
 line-height: var(--n-line-height);
 `), o("loading", [r("data-table-wrapper", `
 opacity: var(--n-opacity-loading);
 pointer-events: none;
 `)]), o("single-column", [r("data-table-td", `
 border-bottom: 0 solid var(--n-merged-border-color);
 `, [e("&::after, &::before", `
 bottom: 0 !important;
 `)])]), n("single-line", [r("data-table-th", `
 border-right: 1px solid var(--n-merged-border-color);
 `, [o("last", `
 border-right: 0 solid var(--n-merged-border-color);
 `)]), r("data-table-td", `
 border-right: 1px solid var(--n-merged-border-color);
 `, [o("last-col", `
 border-right: 0 solid var(--n-merged-border-color);
 `)])]), o("bordered", [r("data-table-wrapper", `
 border: 1px solid var(--n-merged-border-color);
 border-bottom-left-radius: var(--n-border-radius);
 border-bottom-right-radius: var(--n-border-radius);
 overflow: hidden;
 `)]), r("data-table-base-table", [o("transition-disabled", [r("data-table-th", [e("&::after, &::before", "transition: none;")]), r("data-table-td", [e("&::after, &::before", "transition: none;")])])]), o("bottom-bordered", [r("data-table-td", [o("last-row", `
 border-bottom: 1px solid var(--n-merged-border-color);
 `)])]), r("data-table-table", `
 font-variant-numeric: tabular-nums;
 width: 100%;
 word-break: break-word;
 transition: background-color .3s var(--n-bezier);
 border-collapse: separate;
 border-spacing: 0;
 background-color: var(--n-merged-td-color);
 `), r("data-table-base-table-header", `
 border-top-left-radius: calc(var(--n-border-radius) - 1px);
 border-top-right-radius: calc(var(--n-border-radius) - 1px);
 z-index: 3;
 overflow: scroll;
 flex-shrink: 0;
 transition: border-color .3s var(--n-bezier);
 scrollbar-width: none;
 `, [e("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", `
 display: none;
 width: 0;
 height: 0;
 `)]), r("data-table-check-extra", `
 transition: color .3s var(--n-bezier);
 color: var(--n-th-icon-color);
 position: absolute;
 font-size: 14px;
 right: -4px;
 top: 50%;
 transform: translateY(-50%);
 z-index: 1;
 `)]), r("data-table-filter-menu", [r("scrollbar", `
 max-height: 240px;
 `), t("group", `
 display: flex;
 flex-direction: column;
 padding: 12px 12px 0 12px;
 `, [r("checkbox", `
 margin-bottom: 12px;
 margin-right: 0;
 `), r("radio", `
 margin-bottom: 12px;
 margin-right: 0;
 `)]), t("action", `
 padding: var(--n-action-padding);
 display: flex;
 flex-wrap: nowrap;
 justify-content: space-evenly;
 border-top: 1px solid var(--n-action-divider-color);
 `, [r("button", [e("&:not(:last-child)", `
 margin: var(--n-action-button-margin);
 `), e("&:last-child", `
 margin-right: 0;
 `)])]), r("divider", `
 margin: 0 !important;
 `)]), d(r("data-table", `
 --n-merged-th-color: var(--n-th-color-modal);
 --n-merged-td-color: var(--n-td-color-modal);
 --n-merged-border-color: var(--n-border-color-modal);
 --n-merged-th-color-hover: var(--n-th-color-hover-modal);
 --n-merged-td-color-hover: var(--n-td-color-hover-modal);
 --n-merged-th-color-sorting: var(--n-th-color-hover-modal);
 --n-merged-td-color-sorting: var(--n-td-color-hover-modal);
 --n-merged-td-color-striped: var(--n-td-color-striped-modal);
 `)), c(r("data-table", `
 --n-merged-th-color: var(--n-th-color-popover);
 --n-merged-td-color: var(--n-td-color-popover);
 --n-merged-border-color: var(--n-border-color-popover);
 --n-merged-th-color-hover: var(--n-th-color-hover-popover);
 --n-merged-td-color-hover: var(--n-td-color-hover-popover);
 --n-merged-th-color-sorting: var(--n-th-color-hover-popover);
 --n-merged-td-color-sorting: var(--n-td-color-hover-popover);
 --n-merged-td-color-striped: var(--n-td-color-striped-popover);
 `))]);
function s() {
  return [o("fixed-left", `
 left: 0;
 position: sticky;
 z-index: 2;
 `, [e("&::after", `
 pointer-events: none;
 content: "";
 width: 36px;
 display: inline-block;
 position: absolute;
 top: 0;
 bottom: -1px;
 transition: box-shadow .2s var(--n-bezier);
 right: -36px;
 `)]), o("fixed-right", `
 right: 0;
 position: sticky;
 z-index: 1;
 `, [e("&::before", `
 pointer-events: none;
 content: "";
 width: 36px;
 display: inline-block;
 position: absolute;
 top: 0;
 bottom: -1px;
 transition: box-shadow .2s var(--n-bezier);
 left: -36px;
 `)])];
}
export {
  v as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/styles/index.cssr.js
// module id = 1614
// module chunks = 41